import styled from '@emotion/styled';

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

// useMutation hook
import { useMutation, useQueryClient } from '@tanstack/react-query';

//snackbar
import useSnackbarStore from '../../../store/snackbar';

// authservice
import AuthService from '../../../store/auth/AuthService';


const ProfileTab = () => {
  const { data = {} } = usePageData();
  const showSnackbar = useSnackbarStore((state) => state.showSnackbar);
  const queryClient = useQueryClient();

  const { mutate: logOutMutate, isPending } = useMutation({
    mutationFn: AuthService.logOutUser,
    onSuccess: () => {
      showSnackbar('Logged out successfully!', 'success');
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
    onError: (e) => {
      showSnackbar('Failed to log out!', 'error');
    }
  })

  const detailsBlock = [
    {header: "Name", info: data.display_name},
    {header: "Email", info: data.email},
    {header: "Role", info: data.role},
  ];

  const accountBlock = [
    {header: "Active Status", info: data.is_active, dataType: "boolean", booleanValues: ["Active", "Inactive"]},
    {header: "Date Activated", info: data.activated_at, dataType: "date", showField: () => data.is_active},
    {header: "Date Deactivated", info: data.deactivated_at, dataType: "date", showField: () => !data.is_active && data.deactivated_at},
    {header: "Setup Progress", info: data.is_setup, dataType: "boolean", booleanValues: ["Complete", "In-Progress"]},
    {header: "Date Setup", info: data.setup_at, dataType: "date", showField: () => data.is_setup},
  ];

  const loginBlock = [
    {header: "Last Login", info: data.last_login, dataType: "date"},
    {header: "Active Logins", info: data.login_count, dataType: "number"},
  ];
  return (
    <Grid container spacing={3}>
      <Grid size={{xs: 12, md: 4}}>
        <Card variant='outlined'>
          <CardHeader title="Basic Details" />
          <CardContent>
            <CardBlockContainer>
              <CardBlockHeader>Personal Details</CardBlockHeader>
              {detailsBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}
              <CardSpacer />
              <CardBlockHeader>Account Details</CardBlockHeader>
              {accountBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}
              <CardSpacer />
              <CardBlockHeader>Login Details</CardBlockHeader>
              {loginBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}
            </CardBlockContainer>
          </CardContent>
          <CardActions>
            <Button color="error" loading={isPending} onClick={() => logOutMutate(data.user_id)}>Logout User</Button>
          </CardActions>
        </Card>
      </Grid>
      <Grid size={{xs: 12, md: 8}}>
        <Card variant='outlined'>
          <CardHeader title="User Activity" />
          <CardContent>
            Timeline goes here
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );

};

export default ProfileTab;